import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { PostMessageService } from 'src/app/modules/shared/services/post-message.service';
import { WidgetService } from 'src/app/modules/shared/services/widget.service';
import numberToArray from '../../../../../../utils/number-to-array';
import { IHolidayDetail } from '../../interfaces/iholiday-detail';
import { NavigationService } from '../../../../../../services/navigation.service';

@Component({
  selector: 'app-detail-header',
  templateUrl: './detail-header.component.html',
  styleUrls: ['./detail-header.component.scss']
})
export class DetailHeaderComponent implements OnInit, OnChanges, OnDestroy {

  @Input() holidayDetails: IHolidayDetail;
  @Input() bookingUrl: string;
  public isWidget$: Observable<boolean>;
  public isWidget: boolean;
  public isB2B$: Observable<boolean>;
  public location = encodeURI(location.href);
  
  numberToArray = numberToArray;

  constructor(
    private _widgetService: WidgetService,
    private _postMessageService: PostMessageService,
    private _navigationService: NavigationService,
  ) { }

  ngOnInit(): void {
    this.isWidget$ = this._widgetService.isWidget();
    this.isB2B$ = this._postMessageService.isB2B();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bookingUrl && this.bookingUrl) {
      this._navigationService.getRedirectUrl(this.bookingUrl).then(
        (resolved) => {
          this.bookingUrl = resolved.url;
          this.isWidget = resolved.isWidget;
        }
      );
    }
  }

  ngOnDestroy(): void {
  }

}
